// extracted by mini-css-extract-plugin
export default {"amazonBookCard":"AmazonBooks_amazonBookCard__YfzVH","amazonBooksDesktopWrapper":"AmazonBooks_amazonBooksDesktopWrapper__6Tc-k"};